import slugify from "slugify";

export default abstract class Field {

    label: string;
    name: string;
    private value: any;

    constructor(label: string, value: any) {
        this.value = value;
        this.label = label;
        this.name = slugify(this.label).toLowerCase()
    }

    abstract getType(): string

    abstract isEmpty(): boolean

    abstract clear(): Field

    setValue(value?: any) {
        this.value = value
    }

    getValue() {
        return this.value
    }

}